import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconDownload, IconX } from "@tabler/icons-react";

const StudentReportDownload = ({
  open,
  onClose,
  onSelectPDF,
  onSelectCSV,
}: {
  open: boolean;
  onClose: () => void;
  onSelectPDF: () => void;
  onSelectCSV: () => void;
}) => {
  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Baixar relatório de alunos
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="subtitle1" color="secondary.contrastText">
              Selecione o formato no qual deseja realizar o download do
              relatório.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              sx={{ gap: 0.5 }}
              onClick={() => onSelectPDF()}
            >
              <IconDownload size={18} />
              <Typography variant="body2">Baixar PDF</Typography>
            </Button>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              sx={{ gap: 0.5 }}
              onClick={() => onSelectCSV()}
            >
              <IconDownload size={18} />
              <Typography variant="body2">Baixar CSV</Typography>
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default StudentReportDownload;
